export const SideType = {
  Buy: 'Buy',
  Sell: 'Sell',
};

export const OrderStatus = {
  // new: 'New',
  waitPay: 'Pending_payment', // 待支付法币,
  waitReceipt: 'Pending_transfer_confirm', // 待确认已支付,
  transferring: 'Transferring', // 放款中
  success: 'Succeed', // 划转已完成,
  cancel: 'Cancelled', // 订单被取消,
};

export const AppealStatus = {
  normal: 'Normal', // 未发起申诉
  pendingTakeOver: 'PendingTakeOver', // 待客服介入
  appealing: 'Appealing', // 申诉中，客服介入
  pendingOrderCancel: 'PendingOrderCancel', // 待用户取消订单
  appealed: 'Appealed', // 申诉完成
  cancel: 'Cancel', // 申诉取消
};

export const CancelReason = {
  manual: 'manual',
  timeout: 'timeout',
};

export const MakerLevel = {
  general: 'general',
  verified: 'verified',
};

export const OrderProcessingStatus = [OrderStatus.waitPay, OrderStatus.waitReceipt, OrderStatus.transferring];
export const AppealProcessingStatus = [AppealStatus.pendingTakeOver, AppealStatus.appealing, AppealStatus.pendingOrderCancel];

export const PriceScale = 2;
export const PricePrecision = 2;
export const AmountPrecision = 2;
export const AmountScale = 2;
export const SubC2CDisabledLocalKey = 'P2P_SUB_DISABLED_POPUP';
export const FiatCurrencyDefaultConfig = {precision: AmountScale, scale: AmountPrecision, tickSizeEv: 1, factor: 100};

export const P2PTradeDefaultUrlTypeLocalKey = 'P2P_TRADE_DEFAULT_URL_TYPE';

export const AppealReasons = {
  notReceiveDigital: 'NOT_RECEIVE_DIGITAL',
  fiatPaidMuch: 'PAID_TOO_MUCH_MONEY',
  others: 'OTHERS',
};

export const IMMessages = {
  buyerPendingPayment: 'BUYER_PENDING_PAYMENT', // 买家:待付款通知
  sellerPendingPayment: 'SELLER_PENDING_PAYMENT', // 卖家:待付款通知
  buyerPaymentOverDue: 'BUYER_PAYMENT_OVER_DUE', // 买家:法币付款超时
  sellerPaymentOverDue: 'SELLER_PAYMENT_OVER_DUE', // 卖家:法币付款超时
  buyerCancelOrder: 'BUYER_CANCEL_ORDER', // 买家:订单取消
  sellerCancelOrder: 'SELLER_CANCEL_ORDER', // 卖家:订单取消
  buyerPendingTransfer: 'BUYER_PENDING_TRANSFER', // 买家:待放币
  sellerPendingTransfer: 'SELLER_PENDING_TRANSFER', // 卖家:待放币
  buyerTransferOverDue: 'BUYER_TRANSFER_OVERDUE', // 买家:放币超时
  sellerTransferOverDue: 'SELLER_TRANSFER_OVERDUE', // 卖家:放币超时
  buyerSucceed: 'BUYER_SUCCEED', // 买家:放币完成
  sellerSucceed: 'SELLER_SUCCEED', // 卖家:放币完成
  appealCreate: 'APPEAL_CREATE', // 申诉单创建
  appealCancel: 'APPEAL_CANCEL', // 申诉单撤销
  appealTakeOver: 'APPEAL_TAKE_OVER', // 申诉单客服介入
  adminMessage: 'ADMIN_MESSAGE', // 客服留言
  appealUserMessage: 'APPEAL_USER_MESSAGE', // 申诉人留言
  respondentMessage: 'RESPONDENT_MESSAGE', // 被申诉人留言
  appealPendingCancelOrder: 'APPEAL_PENDING_CANCEL_ORDER', // 开启取消订单权限
  appealOrderCancel: 'APPEAL_ORDER_CANCEL', // 申诉撤销
  appealClose: 'APPEAL_CLOSE', // 申诉单关闭
};

export const AppealCloseTypes = [AppealStatus.appealed, AppealStatus.cancel];
